// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, SpeedDial, SpeedDialIcon, SpeedDialAction, Tab, Tabs, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// TODO: Import MUI icon
import { MenuBook } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slide from '../Slide_LT.jpg';

import BoxSubPage from '../../Common/BoxSubPage';
import BoxImage from '../../Common/BoxImage';
import { BoxGridColumnsContainer } from '../../Common/BoxGridColumns';

const EnglishEducation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EnglishEducation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const actions = ['Online Learning Platforms', 'Outstanding Progress Awards', 'Outstanding Reading Award Scheme'];
    const [value, setValue] = React.useState(actions[0]);
    const [open, setOpen] = React.useState(false);

    // TODO: Define event
    const theme = useTheme();

    const handleChange = (event, newValue) => { setValue(newValue) };

    React.useEffect(() => { window.scrollTo(0, 0); }, [value]);
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const documentHeight = document.documentElement.scrollHeight;

            if (documentHeight - scrollPosition < 200) {
                setOpen(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // TODO: Return component
    return (
        <BoxSubPage
            id="EnglishEducation"
            image={Slide}
            title={Text.Top.Menu['LT'].Title[context.language]}
            subtitles={Text.Top.Menu['LT'].Subtitles}
        >
            <Box sx={{ display: { xs: 'none', md: 'inline' }, mb: 2, width: 1 }}>
                <Tabs value={value} onChange={handleChange}>
                    {actions.map((action) => <Tab key={action} icon={<MenuBook />} value={action} label={action} />)}
                </Tabs>
            </Box>
            <Typography variant="h6" sx={{ color: 'primary.main', mb: 2, display: { xs: 'inline', md: 'none' } }}>{value}</Typography>
            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                sx={{ alignItems: 'end', display: { xs: 'flex', md: 'none' }, position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action}
                        FabProps={{
                            sx: {
                                backgroundImage: `linear-gradient(90deg, ${theme.palette.secondary.dark}, ${theme.palette.secondary.light})`,
                                backgroundSize: '200% 200%',
                                justifyContent: 'start',
                                maxWidth: '300px',
                                '&:hover': { backgroundColor: 'secondary.light', },
                            },
                            variant: 'extended'
                        }}
                        icon={
                            <Typography
                                style={{
                                    alignItems: 'center',
                                    color: 'black',
                                    display: 'flex',
                                    gap: 8,
                                    textDecoration: 'none',
                                }}
                            >
                                <MenuBook />
                                <span dangerouslySetInnerHTML={{ __html: action }}></span>
                            </Typography>
                        }
                        onClick={() => {
                            setOpen(false);
                            setValue(action);
                        }}
                    />
                ))}
            </SpeedDial>
            {value === actions[0] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Online Learning Platforms_03.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        We're all about making English fun and engaging for our students! Over the last few years, we've enjoyed using iLearner for reading, but now we're excited to introduce LingoTask! This fantastic platform allows students to explore reading, listening, and writing activities, promoting self-directed learning. With a variety of interactive tasks, everyone can enhance their skills at their own pace. Join us in discovering the exciting world of English, where every lesson feels like an adventure!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Online Learning Platforms_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Online Learning Platforms_02.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[1] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/OutstandingProgressAwards_03.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        The Outstanding Progress Awards are all about celebrating our amazing students for their hard work and positive attitudes-not just their exam results! Teachers pick out special gifts that match each student's unique journey. Plus, everyone gets a certificate to show off their progress. In Term 2, we hand out these certificates during Parents' Day, giving parents a chance to see and cheer for the incredible strides their kids have made in their English learning. It's a fun celebration of growth!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/OutstandingProgressAwards_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/OutstandingProgressAwards_02.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[2] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/OutstandingReadingAwardScheme_02.jpg" sx={{ mb: 1, width: 1 }}  />
                    <Typography sx={{ mb: 1 }}>
                        The Outstanding Reading Awards shine a light on our fantastic readers! In this scheme, students who read a certain number of books earn Bronze, Silver, or Gold awards. Each award comes with cash vouchers to encourage them to buy and explore their own chosen books. It's not just about the number of books read; it's all about their enthusiasm and growth. We love celebrating their achievements with a fun ceremony, inspiring everyone to dive into new stories and adventures in the world of reading!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/OutstandingReadingAwardScheme_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/OutstandingReadingAwardScheme_03.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
        </BoxSubPage >
    );
};
export default EnglishEducation;